import type { FC } from "react";

import type { ColumnFilterProps } from "src/types";
import { isString } from "src/utils";
import { MultiSelect } from "../Form";
import { TABLE_FILTER_HEIGHT } from "./constants";

export const MultiSelectColumnFilter: FC<ColumnFilterProps> = ({ columnId, columnFilter, setColumnFilter, options, dropdownWidth }) => {
    const filterValue = columnFilter ? (columnFilter.value as string) : undefined;

    return (
        <MultiSelect
            options={options ?? []}
            withoutBorder
            withoutErrorPlaceholder
            height={TABLE_FILTER_HEIGHT}
            dropdownWidth={dropdownWidth}
            fontSize="1.2rem"
            value={isString(filterValue) ? [filterValue] : filterValue}
            disableOverflow
            withinPortal
            maxDropdownHeight={300}
            clearable
            searchInputWidth="60px"
            onChange={(value) => {
                setColumnFilter(value?.length ? { id: columnId, value } : undefined); // Set undefined to remove the filter entirely
            }}
        />
    );
};
